/**
 * @generated SignedSource<<b5b45b22bbafcd971efa73c16600d04d>>
 * @relayHash 56ef614e4d6de957ce32f5f26a7824e5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/553.0.0-2026-03-27T10:59:01.810Z/useNotificationsDeleteTagsMutation

import { ConcreteRequest } from 'relay-runtime';
export type UserNotificationsTagEnum = "UNREAD" | "UNVIEWED" | "%future added value";
export type UserNotificationsDeleteTagsInput = {
  activityFeedTagIds?: ReadonlyArray<string | null> | null;
  clientMutationId?: string | null;
  conversationIds?: ReadonlyArray<string | null> | null;
  itemEventTagIds?: ReadonlyArray<string | null> | null;
  tag?: UserNotificationsTagEnum | null;
  userId?: string | null;
};
export type useNotificationsDeleteTagsMutation$variables = {
  input: UserNotificationsDeleteTagsInput;
};
export type useNotificationsDeleteTagsMutation$data = {
  readonly userNotificationsDeleteTags: {
    readonly __typename: "UserNotificationsDeleteTagsPayload";
  } | null;
};
export type useNotificationsDeleteTagsMutation = {
  response: useNotificationsDeleteTagsMutation$data;
  variables: useNotificationsDeleteTagsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserNotificationsDeleteTagsPayload",
    "kind": "LinkedField",
    "name": "userNotificationsDeleteTags",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNotificationsDeleteTagsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNotificationsDeleteTagsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/553.0.0-2026-03-27T10:59:01.810Z/useNotificationsDeleteTagsMutation",
    "metadata": {},
    "name": "useNotificationsDeleteTagsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e6e18a118a80af81ab7f63d30b8999fa";

export default node;
